// extracted by mini-css-extract-plugin
module.exports = {"RealestateVisaUserText":"RealestateField_RealestateVisaUserText__12zpZ","RealestateUserInput":"RealestateField_RealestateUserInput__3sS8p"};